module.exports = __webpack_public_path__ + "img/Wigo_icons_redesign_car_front.1812e41a.svg";